(function () {
	'use strict';
	angular
		.module('app.core')
		.directive('leanChart', leanChart);

	function leanChart() {
		var directive = {
			restrict: 'EA',
			templateUrl: 'core/chart/lean-chart.html',
			scope: {
				getData: '&',
				getMeta: '&'
			},
			link: linkFunc,
			controller: LeanChartCtrl,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		function linkFunc(scope, el, attr, ctrl) {}
	}

	LeanChartCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$state', 'tableFilterFunctionsService', 'leanFilterService', 'leanTableConfigService', 
		'excelExportService', 'URLS', 'storeService', 'FIRST_VIEW', 'siteService', 'localStorageService', 'userService', 'navigationService'];

	function LeanChartCtrl($rootScope, $scope, $timeout, $uibModal, $state, tableFilterFunctionsService, leanFilterService, leanTableConfigService,
			excelExportService, URLS, storeService, FIRST_VIEW, siteService, localStorageService, userService, navigationService) {
		var vm = this;
		this.$onInit = function () { 
			createChart();
		};
		var reportSettingsName;
		var isGlobalReportSetting;
		var reportUrl;
		var extraParams;
		var defaultFilters = [];
		var searchType = '';
		var reportConfigListener;
		var usePost = false;
		var useReportBuilderForExcel = false;
		var reportHasMandatoryFilters = true;
		var noFactory;
		var excelRequest = false;
		var saveErrorUnsub;

		vm.filtered = false;
		vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
		vm.noResultsSuggestion = 'Please try another one.';
		vm.allExpanded = false;
		vm.hideSearch;
		vm.reportIsAuthorized = true;

		vm.groupBy = '';
		vm.displayedData = [];
		vm.search = {};
		vm.searchPlaceholderText = '';
		vm.waitForFilters = false;
		vm.hideFilters = false;
		vm.reloadChart = reloadChart;

		// Search functions
		vm.searchOptionSelected = searchOptionSelected;
		vm.getSearchValues = getSearchValues;
		vm.clearText = clearText;
		vm.searchInputFocused = searchInputFocused;

		$scope.$on('reloadChart', function (event, args) {
			reloadChart();
		});

		function doExport(args) {
			var modalScope = $scope.$new();
			var url = '';
			if (excelRequest) {
				url = URLS.prefix + leanFilterService.getFactoryList() + '/' + vm.tableName + '?';
			} else {
				url = URLS.prefix + leanFilterService.getFactoryList() + '/ExcelReports/' + vm.tableName + '?';
			}
			if (extraParams) {
				for (var i = 0; i < extraParams.length; i++) {
					if (extraParams[i].name != undefined) {
						url = appendQueryParam(url, extraParams[i].name, extraParams[i].value);
					}
				}
			}
			url = encodeURI(url);
			url = appendQueryParam(url, 'excelRequest', true);
			if (usePost) {
				url = leanFilterService.addFilterQueryParams(url, true);
				var data = {};
				var msFilters = leanFilterService.getQueryParam(true, false, true);
				for (var i = 0; i < msFilters.length; i++) {
					data[msFilters[i].key] = msFilters[i].value.toString();
				}
				return excelExportService.getExcelReportNew(vm.tableName, leanFilterService.getFactoryList(), data, url, modalScope, undefined, undefined, args.exportFileName);
			} else if (useReportBuilderForExcel) {
				var body = {};
				var tempUrl = args.alternateUrl ? args.alternateUrl : reportUrl;
				url = (noFactory ? '2/' : URLS.prefix) +
					String.format(tempUrl, leanFilterService.getFactoryList());
				body.excelExportType = args.type;
				body.filters = leanFilterService.getFiltersForPost();
				body.operation = 'excelExport';
				return excelExportService.getExcelReportNew(vm.tableName, leanFilterService.getFactoryList(), body, url, modalScope, true, args.isCsv, args.exportFileName);
			} else {
				url = URLS.host + leanFilterService.addFilterQueryParams(url);
				return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), url, modalScope, undefined, undefined, args.exportFileName);
			}	
		}
		
		$scope.$on('export-excel', function (event, args) {
			if (!args) {
				args = {};
			}
			return doExport(args);
		});

		$scope.$watch('reportsItemLoading', function(loading) {
			if (loading) {
				jQuery('.report-item-search-typeahead ul.dropdown-menu').hide();
			} else {
				jQuery('.report-item-search-typeahead ul.dropdown-menu').show();
			}
		});


		function reportConfigReady(reportConfig) {
			if (reportSettingsName === globalReportName || vm.getMeta().reportSettingsId === globalReportName) {
				var reportSettings = storeService.getState().reportSettings;
				if (['dashboards', 'savedReports', 'savedLeanProjects'].indexOf(reportSettings.viewType) > -1) {
					if (reportSettings.identifierNdx && reportSettings.identifierNdx !== globalConfig.customer.id) {
						var sitesByCustomer = siteService.getSitesByCustomer(reportSettings.identifierNdx);
						if (sitesByCustomer.length) {
							var customerName = globalConfig.user.authFacts[sitesByCustomer[0].id].customerName;
							showSiteSwitchModal(reportSettings.viewType, reportSettings.reportName, customerName, reportSettings.identifierNdx);
						} else {
							goToHome(reportSettings.viewType);
						}
						return;
					}
				}
				vm.reportIsAuthorized = storeService.getState().reportSettings.authorizationLevel !== 'NONE';
				if (vm.reportIsAuthorized) {
					processConfig(reportConfig);
					if (vm.waitForFilters) {
						leanFilterService.loadFilters(true);
						getData(undefined, false, vm.waitForFilters);
					} else {
						getData(undefined, true, vm.waitForFilters);
					}
				} else {
					$scope.$emit('hideButtonsForMissingSites');
				}
			}
		}

		function createChart() {
		// Get Meta Info for Report
			var meta = vm.getMeta();
			globalReportName = meta.reportSettingsId || meta.reportSettingsName;
			reportSettingsName = meta.reportSettingsName;
			isGlobalReportSetting = meta.isGlobalReportSetting;
			extraParams = meta.extraParams;
			searchType = meta.searchType ? meta.searchType : 'item';
			leanFilterService.searchType = searchType;
			defaultFilters = meta.defaultFilters;
			usePost = typeof meta.usePost !== 'undefined' && meta.usePost;
			useReportBuilderForExcel = typeof meta.useReportBuilderForExcel !== 'undefined' && meta.useReportBuilderForExcel;
			reportHasMandatoryFilters = typeof meta.hasMandatoryFilters !== 'undefined' && meta.hasMandatoryFilters;

			vm.searchType = searchType;
			reportUrl = meta.reportUrl;
			noFactory = meta.noFactory;
			vm.hideSearch = meta.hideSearch;
			vm.footer = meta.footer;
			vm.showExcel = extraParams[0].showExcel || meta.showExcel;
			vm.tableName = extraParams[0].excelReportName || meta.reportSettingsName;
			vm.searchPlaceholderText = meta.specialPlaceholderText ? meta.specialPlaceholderText : 'Search ' + searchType + 's...';
			vm.hideFilters = typeof meta !== 'undefined' && meta.hideFilters;
			vm.waitForFilters = meta.waitForFilters || false;
			vm.useBackendCurrencyConversion = typeof meta.useBackendCurrencyConversion !== 'undefined' && meta.useBackendCurrencyConversion;
			excelRequest = meta.excelRequest;

			// Set Filters
			$scope.filterService = leanFilterService;
			$scope.filters = leanFilterService.masterFilterList;
			$scope.rangeFilters = leanFilterService.masterRangeFilterList;
			$scope.stringFilters = leanFilterService.masterStringFilterList;
			$scope.singleSelectFilters = leanFilterService.masterSingleSelectFilterList;
			leanFilterService.setSearchBoxDataValue('');
			leanFilterService.clearFiltersLoaded();
			setFilterFunctions();

			var reportSettingsScope = meta.reportSettingsScope || 'customer';
			reportSettingsScope = isGlobalReportSetting ? 'global' : reportSettingsScope;

			leanFilterService.setResetReportSettingsSettings(reportSettingsName, reportSettingsScope);
			reportConfigListener = $rootScope.$on('reportConfigReady', function () {
				reportConfigReady(storeService.getState().reportSettings);
			});
			leanTableConfigService.setExtraFilters(meta.extraFilters);
			leanTableConfigService.setMandatoryDefaultFilters(reportHasMandatoryFilters);
			leanTableConfigService.setDefaultFilters(defaultFilters);
			storeService.dispatch(storeService.actionCreators.setDefaultFilters(defaultFilters));
			leanTableConfigService.setReportSettingsId(meta.reportSettingsId);
			var viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';
			$timeout(function () {
				leanTableConfigService.getConfig(undefined, reportSettingsName, reportSettingsScope, viewType);
			});
		}

		function processConfig(reportConfig) {
			if (reportConfig && reportConfig.search) {
				vm.search.term = reportConfig.search;
				vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
				vm.noResultsSuggestion = 'Please try another one.';
				vm.filtered = false;
			}
			if (reportConfig && reportConfig.filters) {
				vm.noResultsText = 'We couldn\'t find any results that match this filter.';
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
			}
		}


		function getData(start, loadFilters, waitForFilters, isFilterChanged) {
			if (!waitForFilters || !leanFilterService.isLoading()) {
				var params = {
					reportName: reportSettingsName,
					url: reportUrl,
					noFactory: noFactory,
					usePost: usePost
				};
				vm.getData({
					'params': params,
					'extraParams': extraParams,
					'isFilterChanged': isFilterChanged
				});
				if (loadFilters) {
					$timeout(function () {
						if (reportSettingsName === globalReportName || vm.getMeta().reportSettingsId === globalReportName) {
							leanFilterService.loadFilters();
						}
					});
				}
			} else {
				setTimeout(function () {
					getData(start, loadFilters, waitForFilters, isFilterChanged);
				}, 10);
			}
		}

	
		/**
		 * The report filters have 3 functions that need to call
		 * a scope function (specifically getData)
		 * Defining them here allows the passing of a callback function
		 */
		function setFilterFunctions() {
			$scope.filterFunctions = tableFilterFunctionsService;
			vm.noResultsText = 'We couldn\'t find any results that match this filter.';
			// Filter related functions
			$scope.filterFunctions.applySelection = function ($event, filterId) {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.applySelectionInner($event, getData, filterId, true, reportSettingsName, vm.getMeta().reportSettingsId);
			};
			$scope.filterFunctions.removeFilter = function (filter) {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.removeFilterInner(filter, getData, true, reportSettingsName, vm.getMeta().reportSettingsId);
			};
			$scope.filterFunctions.clearAllFilters = function () {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.clearAllFiltersInner(getData, true, reportSettingsName, vm.getMeta().reportSettingsId, defaultFilters);
			};
		}

		function reloadChart() {
			getData();
		}

		function searchInputFocused() {
			if (vm.search && vm.search.term) {
				if (vm.search.term.indexOf('Starts with') === 0) {
					vm.search.term = vm.search.term.substring(13, vm.search.term.length - 1);
				} else if (vm.search.term.indexOf('Contains') === 0) {
					vm.search.term = vm.search.term.substring(10, vm.search.term.length - 1);
				}
			}
		}

		function searchOptionSelected(searchTerm, searchItem, event) {
			if ($scope.reportsItemLoading) {
				vm.search.term = vm.searchValue;
				return;
			}
			var currentSearchTermSelected = leanFilterService.getSearchBoxDataValue();
			var selectedSearchTerm = vm.search.term;
			if (searchType === 'item' && typeof searchItem !== 'undefined') {
				selectedSearchTerm = searchItem.fullItemCode === undefined ? searchItem.itemCode : searchItem.fullItemCode;
			}
			if (currentSearchTermSelected !== selectedSearchTerm) {
				vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
				vm.noResultsSuggestion = 'Please try another one.';
				vm.filtered = false;
				leanFilterService.setSearchBoxDataValue(selectedSearchTerm);
				getData(0, undefined, undefined, 'filtersChanged');
			}
			if (event && event.target) {
				jQuery(event.target).blur();
			}
		}

		function getSearchValues(name) {
			vm.searchValue = name;
			var partialMatch = 'Contains "' + name + '"';

			if (globalConfig.user.role == 'Supplier') {
				return [{itemCode: partialMatch}];
			}
			return leanFilterService.getSearchData(name).then(function (response) {
				if (response && response.data && response.data.length) {
					var sortField;
					if (searchType === 'supplier') {
						sortField = 'name';
					} else if (searchType === 'user') {
						sortField = 'term';
					}
					response.data.sort(function (a, b) {
						return (a[sortField].length - b[sortField].length) || a[sortField].localeCompare(b[sortField]);
					});
					return response.data;
				}
				if (searchType === 'item' && response.data.data && response.data.data.length) {
					var returnList = response.data.data;
					returnList.push({itemCode: partialMatch});
					return returnList;
				}
				return [];
			});
		}

		function showSiteSwitchModal(viewType, reportName, customerName, identifierNdx) {
			var modalScope = $scope.$new();
			modalScope.switch = {
				'typeOfView': viewType === 'dashboards' ? 'dashboard' : 'saved report',
				'viewName': reportName,
				'customerName': customerName
			};

			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/core/navigation/switch-site-modal.html'
			};
			var siteChangedModal = $uibModal.open(opts);

			modalScope.closeModal = function() {
				siteChangedModal.close();
				goToHome(viewType);
			};

			modalScope.switchSite = function() {
				navigationService.getLoginSiteForCustomer(identifierNdx).then(function (data) {
					localStorageService.set('newSiteId', data.factoryNdx);
					userService.switchSite(data.factoryNdx, true);
				});
			};
		}

		function goToHome(viewType) {
			if (viewType === 'dashboards') {
				$state.go('app.dashboard');
			} else {
				$state.go('.', {reportId: undefined});
			}
		}


		function clearText(param) {
			vm.search.term = param;
			vm.searchOptionSelected({
				searchTerm: ''
			});
			$timeout(function () {
				jQuery('.searchBlock .search input').focus();
			});
		}

		$scope.$on('$destroy', function () {
			saveErrorUnsub && saveErrorUnsub();
			if (reportConfigListener) {
				reportConfigListener();
			}
		});
	}
})();
